<template>
<div class="client-invoice-summary">
    <div class="cis-title">{{ $t('clients.account_summary') }}</div>
    <div class="cis-kpis">
        <div class="cis-kpi">
            <template v-if="summary.openBalanceList.length > 0">
                <div v-for="balance in summary.openBalanceList" :key="balance.currency" class="cis-value" :class="{ 'cis-alert': hasOpenBalance }">
                    {{ $formatMoneyTr(balance.total) }} {{ balance.currency }}
                </div>
            </template>
            <div v-else class="cis-value">—</div>
            <div class="cis-label">{{ $t('clients.open_balance') }}</div>
        </div>
        <div class="cis-kpi">
            <div class="cis-value">{{ summary.openInvoiceCount }}</div>
            <div class="cis-label">{{ $t('clients.open_invoice_count') }}</div>
        </div>
        <div class="cis-kpi">
            <div class="cis-value" :class="{ 'cis-alert': hasOpenBalance && summary.oldestUnpaidDays !== null }">
                {{ summary.oldestUnpaidDays !== null ? summary.oldestUnpaidDays + ' ' + $t('clients.day') : '—' }}
            </div>
            <div class="cis-label">{{ $t('clients.oldest_open_invoice') }}</div>
        </div>
    </div>
    <div class="cis-rows">
        <span class="cis-row-label">{{ $t('clients.last_payment') }}</span>
        <span class="cis-row-value">
            <template v-if="summary.lastPayment">
                {{ $formatFn(summary.lastPayment.paymentDate) }} · {{ $formatMoneyTr(summary.lastPayment.total) }} {{ summary.lastPayment.currency }}
            </template>
            <template v-else>—</template>
        </span>
        <span class="cis-row-label">{{ $t('clients.last_12_months_total') }}</span>
        <span class="cis-row-value">
            <template v-if="summary.last12MonthsTotalList.length > 0">
                <div v-for="item in summary.last12MonthsTotalList" :key="item.currency">{{ $formatMoneyTr(item.total) }} {{ item.currency }}</div>
            </template>
            <template v-else>—</template>
        </span>
    </div>
</div>
</template>

<script>
// STOCK-2979: Ajan Bilgisi > Hesap Özeti. Değerler filtrelerden bağımsız, salt okunur.
const emptySummary = () => ({
    openBalanceList: [],
    openInvoiceCount: 0,
    oldestUnpaidDays: null,
    lastPayment: null,
    last12MonthsTotalList: []
})

export default {
    props: {
        lawClientId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            summary: emptySummary()
        }
    },
    computed: {
        hasOpenBalance() {
            return this.summary.openBalanceList.some(balance => balance.total > 0)
        }
    },
    mounted() {
        this.getSummary()
    },
    methods: {
        getSummary() {
            this.summary = emptySummary()
            const payload = {
                data: { id: this.lawClientId },
                controller: { name: 'LawInvoice', actionName: 'GetLawClientInvoiceSummary' }
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.summary = Object.assign(emptySummary(), response.data, {
                        openBalanceList: response.data.openBalanceList || [],
                        last12MonthsTotalList: response.data.last12MonthsTotalList || []
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    }
}
</script>

<style lang="scss">
.client-invoice-summary {
    background-color: #F9FAFB;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    padding: 12px 14px;
    height: 100%;

    .cis-title {
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: .04em;
        color: #6B7280;
        margin-bottom: 10px;
    }

    .cis-kpis {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        margin-bottom: 10px;
    }

    .cis-kpi {
        background-color: #FFFFFF;
        border: 1px solid #E5E7EB;
        border-radius: 5px;
        padding: 8px 10px;
    }

    .cis-value {
        font-size: 18px;
        font-weight: 700;
        color: #111827;
    }

    .cis-value.cis-alert {
        color: #B91C1C;
    }

    .cis-label {
        font-size: 11px;
        color: #6B7280;
    }

    .cis-rows {
        display: grid;
        grid-template-columns: 160px 1fr;
        row-gap: 6px;
        font-size: 13px;
        align-items: baseline;
    }

    .cis-row-label {
        color: #6B7280;
    }

    /* Değerler etiketlerden ayrışsın: kart sayılarıyla aynı renk, kalın */
    .cis-row-value {
        color: #111827;
        font-size: 14px;
        font-weight: 600;
    }
}
</style>
